export const NAVIGATION_OPEN_CLASS =
  'desktop-navigation__dropdown-content--open';

export default class DesktopKeyboardNavigation {
  constructor(element) {
    this.element = element;

    if (!!this.element) {
      this.attachEvents();
    }
  }

  closeDropdowns() {
    const dropdowns = this.element.querySelectorAll(
      '[data-js="desktop-navigation-dropdown"]'
    );

    if (dropdowns) {
      for (let i = 0; i < dropdowns.length; i++) {
        dropdowns[i].classList.remove(NAVIGATION_OPEN_CLASS);
      }

      const primaryNavItems = this.getPrimaryNavItems();
      for (let i = 0; i < primaryNavItems.length; i++) {
        const item = primaryNavItems[i].querySelector('[aria-expanded="true"]');
        if (item) item.setAttribute('aria-expanded', false);
      }
    }
  }

  getPrimaryNavItems = () =>
    document.querySelectorAll('[data-js="desktop-navigation-primary-item"]');

  toggleDropdown = dropdown => dropdown.classList.toggle(NAVIGATION_OPEN_CLASS);

  toggleDropdownIfExists = event => {
    const dropdown = event.target.parentElement.querySelector(
      '[data-js="desktop-navigation-dropdown"]'
    );

    if (dropdown) {
      const isOpen = this.toggleDropdown(dropdown);
      event.target.setAttribute('aria-expanded', isOpen);
      return dropdown;
    }
  };

  handleMouseOver = () => {
    this.closeDropdowns();
  };

  handleKeyUp = event => {
    if (
      event.key === 'Tab' &&
      !event.target.closest('[data-js="desktop-navigation-dropdown"]')
    ) {
      this.closeDropdowns();
    }
  };

  handleKeyDown = event => {
    if (event.key !== 'Enter') return;

    const dropdown = this.toggleDropdownIfExists(event);
    if (dropdown) event.preventDefault();
  };

  handleTouch = event => {
    const dropdown = event.target.parentElement.querySelector(
      '[data-js="desktop-navigation-dropdown"]'
    );
    // Touch screen devices should already apply the hover state on touch,
    // which will handle showing the dropdown. We want to prevent touch
    // events from bubbling up to the click event so that touch screen
    // users can open dropdowns without navigating to links associated
    // with the navigation item they clicked.
    if (dropdown) event.preventDefault();
  };

  handleClick = this.toggleDropdownIfExists;

  attachEvents() {
    // Close all open dropdowns when the user moves the mouse (won't close if
    // moved in the dropdown area)
    document.addEventListener('mouseover', this.handleMouseOver, false);

    // Close all open dropdown if the user hit Tab and it moves focus outside of
    // the dropdown.
    document.addEventListener('keyup', this.handleKeyUp, false);

    // Select all aveeno nav primary items
    const primaryItems = this.getPrimaryNavItems();

    // For each primary item, we need to support three different types of input:
    // keyboard, touch, and mouse. Keyboard and touch screen users need to be
    // able to toggle the dropdown without clicking on any links that might be
    // associated with the primary item. Mouse users can click on the primary
    // item if it has a link associated with it, while being able to toggle
    // the dropdown via hover.
    for (let i = 0; i < primaryItems.length; i++) {
      const element = primaryItems[i].querySelector('a, button');

      element.addEventListener('keydown', this.handleKeyDown);
      element.addEventListener('touchend', this.handleTouch);
      element.addEventListener('click', this.handleClick);
    }
  }

  detachEvents() {
    document.removeEventListener('mouseover', this.handleMouseOver);
    document.removeEventListener('keyup', this.handleKeyUp);

    const primaryItems = this.getPrimaryNavItems();

    for (let i = 0; i < primaryItems.length; i++) {
      const element = primaryItems[i].querySelector('a, button');

      element.removeEventListener('keydown', this.handleKeyDown);
      element.removeEventListener('touchend', this.handleTouch);
      element.removeEventListener('click', this.handleClick);
    }
  }
}
